'use client';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from 'components/customercenter-ui/components/ui/toast';
import { useToast } from 'components/customercenter-ui/components/ui/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const isHtmlString = typeof description === 'string' && /<[^>]+>/.test(description);
        return (
          <Toast key={id} {...props}>
            {action}
            <div className="grid w-full gap-1 text-center font-medium">
              {title && <ToastTitle className="font-medium">{title}</ToastTitle>}
              {description && (
                <ToastDescription
                  className="font-medium"
                  {...(isHtmlString ? { dangerouslySetInnerHTML: { __html: description } } : { children: description })}
                />
              )}
            </div>
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport className="sm:left-1/2 sm:top-0 sm:-translate-x-1/2" />
    </ToastProvider>
  );
}
